<div id="floating-download-links" class="duration-100 rounded-t-3xl bg-slate-100/[.75] backdrop-blur-md p-4 block md:hidden fixed z-50 bottom-0 translate-y-full w-full max-w-96 left-1/2 -translate-x-1/2">
  <h3>دانلود اپلیکیشن</h3>
  <div class="mt-2 flex gap-4 justify-center *:size-12">
    <a href="https://www.google.com" target="_blank"><img src="assets/icons/play_store.svg" alt="playstore logo" (click)="getDevice()" /></a>
    <a href="https://www.google.com" target="_blank"><img src="assets/icons/sib_che.svg" alt="sibche logo" (click)="getDevice()" /></a>
    <a href="https://www.google.com" target="_blank"><img src="assets/icons/apk.svg" alt="apk logo" (click)="getDevice()" /></a>
    <a href="https://www.google.com" target="_blank"><img src="assets/icons/bazar.svg" alt="bazar logo" (click)="getDevice()" /></a>
  </div>
</div>
